import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
const META_PIXEL_ID = '1318252740201550';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
        return;
      }
      fbq.queue?.push(args);
    } as MetaPixelFunction;
    fbq.push = args => fbq.queue?.push(args);
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = META_PIXEL_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-102">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-103" />
    </noscript>;
}